import { Injectable, inject } from '@angular/core';
import { Observable, map, tap } from 'rxjs';

import { HttpService } from '@services/http.service';
import { SessionService } from '@services/utils/session.service';
import { EndpointParams } from '@models/utils/endpoint-params';
import { MemberInfo } from '@models/index';

@Injectable({
    providedIn: 'root'
})
export class MemberInfoService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private readonly sessionService = inject(SessionService);

    info(): Observable<MemberInfo> {
        return this.get('member/info', this.defaultEndpointParams);
    }

    refreshCanBook(): Observable<boolean> {
        return this.info().pipe(
            tap(memberInfo => this.sessionService.setCanBook(memberInfo.canBook)),
            map(memberInfo => memberInfo.canBook)
        );
    }
}
